import React from 'react';
import { MEDIA_TYPE } from '@whatsper/texterchat-common';
import ImageMessage from '../../../../ImageMessage';
const StoryMention = ({ storyMention, direction }) => {
    const inlineMedia = { url: storyMention === null || storyMention === void 0 ? void 0 : storyMention.url, mediaType: MEDIA_TYPE.IMAGE };
    return (React.createElement(ImageMessage, { messageId: "inline-story-mention", media: inlineMedia, direction: direction, imageMessages: [Object.assign(Object.assign({}, inlineMedia), { index: 0 })], showCaption: false }));
};
export default StoryMention;
